/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectLogoDto } from '../../models/backend-project-logo-dto';
import { BackendProjectLogoRequestDto } from '../../models/backend-project-logo-request-dto';

export interface ProjectsProjectsLogoUpdateUpdate$Params {
  id: number;
  body?: BackendProjectLogoRequestDto;
}

export function projectsProjectsLogoUpdateUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsLogoUpdateUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectLogoDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsLogoUpdateUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectLogoDto>;
    }),
  );
}

projectsProjectsLogoUpdateUpdate.PATH = '/api/projects/projects/logo/update/{id}/';
